import type { Currency } from "./constants.js";

export const CURRENCY_SYMBOL: Record<Currency, string> = { AUD: "$", INR: "₹" };

/**
 * A money figure with its currency's symbol. `null` is a currency nobody has
 * read: the number goes out bare, never dressed as dollars it may not be.
 */
export function money(n: number, currency: Currency | null = "AUD"): string {
  return (
    (currency === null ? "" : CURRENCY_SYMBOL[currency]) +
    n.toLocaleString("en-AU", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  );
}

/**
 * Hours as text. One decimal, but a whole number of hours is written as one:
 * "24 hrs", not "24.0 hrs". Hours are entered in 0.5 steps (TIME rules), so the
 * only fraction that ever survives is `.5` and there is nothing to round away.
 */
export function hours(n: number): string {
  return n.toFixed(1).replace(/\.0$/, "");
}

export function initials(name: string): string {
  return name
    .split(" ")
    .map((s) => s[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

// `avatarColor` used to live here and returned Tailwind class names. It has moved
// to `apps/web/src/components/ui/layout.tsx`: Tailwind never scans this package,
// so the classes were never emitted — and naming presentation is the web app's
// job, not the domain's.
